import Offcanvas from "react-bootstrap/Offcanvas";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import { Row, Col, FormControl, Spinner } from "react-bootstrap";
import "./CartSidebar.css";
import { useCartWishlist } from "../context/CartWishlistContext";
import { getAnonUserId, getHostName } from "../helpers/utils";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import React from "react";
import ReactPixel from "react-facebook-pixel";
import { toast } from "react-toastify";

export default function CartSidebar({
  show,
  handleClose,
  // cartList = [],
  // removeItemFromCart,
  // updateQuantity,
  // handleNavigateToCheckOut,
  // cartLoader = false,
}) {
  const { cartList, removeItemtoCart, updateQuantity } = useCartWishlist();

  const [cartLoader, setCartLoader] = React.useState(false);

  const hostname = getHostName();

  const navigate = useNavigate();

  const handleNavigateToCheckOut = () => {
    // UPDATE IN DB
    setCartLoader(true);

    // Track InitiateCheckout with simple cart metadata
    try {
      if (ReactPixel && typeof ReactPixel.trackCustom === "function") {
        const cartValue = cartList.reduce((acc, item) => acc + (item.product?.price || 0) * (item.quantity || 0), 0);
        ReactPixel.trackCustom("InitiateCheckout", {
          itemsCount: cartList.length,
          value: parseFloat(cartValue.toFixed(2)),
          currency: "PKR",
        });
      }
    } catch (e) {}

    let anonUserId = getAnonUserId();

    axios
      .post(`${hostname}/api/cart/bulk-update`, {
        annoUserDeviceId: anonUserId,
        items: cartList,
      })
      .then((res) => {
        console.log(res.data);
        setTimeout(() => {
          setCartLoader(false);
        }, 800);
        setTimeout(() => {
          navigate("/checkout");
        }, 1000);

        // toast.success("Items updated.", { theme: "colored" });
        console.log("database updated");
      })
      .catch((err) => {
        console.log(err);
        setCartLoader(false);
        if ("response" in err)
          toast.error(err.response.data.error, { theme: "colored" });
        else toast.error("something went wrong!", { theme: "colored" });
      });
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      backdrop="static"
      placement="end"
      className="custom-offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>My Cart</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {cartList.length === 0 ? (
          <div
            style={{
              minHeight: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p className="text-muted">Your cart is empty.</p>
          </div>
        ) : (
          cartList.map((item) => (
            <div
              key={item.product._id}
              className="cart-item border-bottom pb-3 mb-3"
            >
              <Row>
                <Col xs={4} className="text-center">
                  <Image
                    src={item.product.imageUrl || "/img/product/1.jpg"}
                    alt={item.product.title}
                    fluid
                    rounded
                  />
                </Col>
                <Col xs={8}>
                  <h6>{item.product.title}</h6>
                  <p className="text-muted small mb-1">{item.product.brand}</p>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <strong className="text-success">
                      Rs {item.product.price}
                    </strong>
                    <span className="text-muted text-decoration-line-through">
                      Rs {item.product.originalPrice}
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() =>
                        updateQuantity(item.product._id, item.quantity - 1)
                      }
                    >
                      -
                    </Button>
                    <FormControl
                      value={item.quantity}
                      readOnly
                      className="text-center mx-2"
                      style={{ maxWidth: "50px" }}
                    />
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() =>
                        updateQuantity(item.product._id, item.quantity + 1)
                      }
                    >
                      +
                    </Button>
                    <Button
                      variant="link"
                      className="text-danger ms-2"
                      onClick={() => removeItemtoCart(item.product._id)}
                    >
                      <i className="bi bi-trash" />
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          ))
        )}
        {cartList.length > 0 && (
          <div className="text-end mt-3">
            <Button
              disabled={cartLoader}
              style={{ minWidth: "130px" }}
              onClick={handleNavigateToCheckOut}
              variant="success"
            >
              {cartLoader ? <Spinner size="sm" /> : "Checkout"}
            </Button>
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
}
